import SharedDownloadView, { type SharedDownloadAction, type SharedDownloadImage } from "../../sharedComponents/downloadView"
import s_homePreview from "./assets/spring/h_preview.jpg"
import s_homeScreen from "./assets/spring/h_screen.png"
import s_lockPreview from "./assets/spring/l_preview.jpg"
import s_lockScreen from "./assets/spring/l_screen.png"
import summer_homePreview from "./assets/summer/h_preview.jpg"
import summer_homeScreen from "./assets/summer/h_screen.png"
import summer_lockPreview from "./assets/summer/l_preview.jpg"
import summer_lockScreen from "./assets/summer/l_screen.png"
import n_homePreview from "./assets/night/h_preview.jpg"
import n_lockPreview from "./assets/night/l_preview.jpg"
import n_homeScreen from "./assets/night/h_screen.png"
import n_lockScreen from "./assets/night/l_screen.png"
import a_homePreview from "./assets/autumn/h_preview.jpg"
import a_lockPreview from "./assets/autumn/l_preview.jpg"
import a_homeScreen from "./assets/autumn/h_screen.png"
import a_lockScreen from "./assets/autumn/l_screen.png"
import w_homePreview from "./assets/winter/h_preview.jpg"
import w_lockPreview from "./assets/winter/l_preview.jpg"
import w_homeScreen from "./assets/winter/h_screen.png"
import w_lockScreen from "./assets/winter/l_screen.png"

interface DownloadViewProps {
    type?: string
}

interface ThemeAsset {
    home: string
    lock: string
    isAvailable: boolean
    deepLink: string
    homeDownload: string
    lockDownload: string
}

const getImageFileName = (themeType: string, screenType: string, imageUrl: string) => {
    const extension = imageUrl.split("?")[0].match(/\.(png|jpe?g|webp)$/i)?.[1] || "png"

    return `dodu-${themeType}-${screenType}.${extension}`
}

const assets: Record<string, ThemeAsset> = {
    spring: {
        home: s_homePreview,
        lock: s_lockPreview,
        isAvailable: true,
        deepLink: "https://apps.samsung.com/theme/ProductDetail.as?appId=com.SamTheme_DODU_Spring&from=GBadge_01_8845021_tag",
        homeDownload: s_homeScreen,
        lockDownload: s_lockScreen,
    },
    summer: {
        home: summer_homePreview,
        lock: summer_lockPreview,
        isAvailable: true,
        deepLink: "https://apps.samsung.com/theme/ProductDetail.as?appId=com.SummerCampuswithDODU&from=GBadge_01_8862823_tag",
        homeDownload: summer_homeScreen,
        lockDownload: summer_lockScreen,
    },
    night: {
        home: n_homePreview,
        lock: n_lockPreview,
        isAvailable: true,
        deepLink: "https://apps.samsung.com/theme/ProductDetail.as?appId=com.Night_CampuswithDODU&from=GBadge_01_8876754_tag",
        homeDownload: n_homeScreen,
        lockDownload: n_lockScreen,
    },
    autumn: {
        home: a_homePreview,
        lock: a_lockPreview,
        isAvailable: true,
        deepLink: "https://apps.samsung.com/theme/ProductDetail.as?appId=com.AutumnCampuswithDODU&from=GBadge_01_8904041_tag",
        homeDownload: a_homeScreen,
        lockDownload: a_lockScreen,
    },
    winter: {
        home: w_homePreview,
        lock: w_lockPreview,
        isAvailable: true,
        deepLink: "https://apps.samsung.com/theme/ProductDetail.as?appId=com.WinterCampuswithDODU&from=GBadge_01_8913048_tag",
        homeDownload: w_homeScreen,
        lockDownload: w_lockScreen,
    },
}

const DownloadView = ({ type = "spring" }: DownloadViewProps) => {
    const current = assets[type] || assets.spring
    const images: SharedDownloadImage[] = [
        {
            component: current.lock ? (
                <img
                    src={current.lock}
                    className="h-full w-full object-cover"
                    alt="LockScreen"
                />
            ) : null,
            caption: "잠금 화면",
        },
        {
            component: current.home ? (
                <img
                    src={current.home}
                    className="h-full w-full object-cover"
                    alt="HomeScreen"
                />
            ) : null,
            caption: "홈 화면",
        },
    ]
    const actions: SharedDownloadAction[] = [
        {
            id: "theme-download",
            label: "테마 다운로드",
            subLabel: "for Galaxy",
            variant: "solid",
            href: current.deepLink,
        },
        {
            id: "image-download",
            label: "이미지 다운로드",
            variant: "outline",
            shareTitle: "DODU images",
            files: [
                {
                    src: current.lockDownload,
                    fileName: getImageFileName(type, "lockscreen", current.lockDownload),
                },
                {
                    src: current.homeDownload,
                    fileName: getImageFileName(type, "homescreen", current.homeDownload),
                },
            ].filter((file) => file.src),
        },
    ]

    return (
        <SharedDownloadView
            isAvailable={current.isAvailable}
            images={images}
            actions={actions}
        />
    )
}

export default DownloadView
